const TOKEN_KEY = "token";

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const getTokenPayload = (token) => {
  if (!token || typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const normalized = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};

export const isTokenUsable = (token) => {
  const payload = getTokenPayload(token);
  return Boolean(payload?.exp && payload.exp * 1000 > Date.now());
};

export const getTokenUserId = (token) => {
  const subject = getTokenPayload(token)?.sub;
  const userId = String(subject ?? "");
  return /^\d+$/.test(userId) ? userId : null;
};
